// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addons: { [key: string]: any | undefined } = {};
